import { TabView, TabPanel } from 'primereact/tabview';
import TrainerBookingPopup from './TrainerBookingPopup';
import { useState } from 'react';

const TrainerCourseContent = ({ props, coursePackagesData }) => {
  const { coursePackages, trainerPopup } = props;
  const [visible, setVisible] = useState(false);
  return (
    <>
      <div
        className="border-1 border-round-md shadow-6 w-full xl:py-4 xl:px-3 py-3 px-2"
        style={{ borderColor: '#CBD5E1' }}
      >
        <p className="text-center text-2xl font-medium mt-0 mb-3">
          {coursePackages.packagesTitle}
        </p>
        <TabView className="trainer-detail-tabs" scrollable>
          {coursePackagesData.map((item) => {
            return (
              <TabPanel header={item.title} className="w-full" key={item.title}>
                <div className="flex flex-column gap-2">
                  {item.packages.map((packageItem) => {
                    return (
                      <div
                        className="border-1 border-round-md px-4 py-2 flex justify-content-between align-items-center hover:bg-primary cursor-pointer"
                        style={{ borderColor: '#CBD5E1' }}
                        onClick={() => setVisible(true)}
                      >
                        <div className="flex flex-column gap-1">
                          <span className="text-2xl">
                            {formatter.format(packageItem.price)}
                          </span>
                          <div className="flex gap-1 flex-wrap">
                            <span className="text-sm">
                              {packageItem.totalLesson} {coursePackages.lessons}
                            </span>
                            <span className="text-sm">
                              {packageItem.totalMinutes}{' '}
                              {coursePackages.minutes}
                            </span>
                          </div>
                        </div>
                        <div className="flex gap-1 align-items-center">
                          {packageItem.sale ? (
                            <div
                              className="border-round-md text-sm white-space-nowrap"
                              style={{
                                backgroundColor: '#FFF7ED',
                                color: '#F97316',
                                padding: '0.5rem 0.75rem',
                              }}
                            >
                              {packageItem.sale}% off
                            </div>
                          ) : null}
                          <i className="pi pi-chevron-right"></i>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </TabPanel>
            );
          })}
        </TabView>
      </div>
      <TrainerBookingPopup
        visible={visible}
        onHide={() => setVisible(false)}
        text={trainerPopup}
      />
    </>
  );
};
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  trailingZeroDisplay: 'stripIfInteger',
});

export default TrainerCourseContent;
